<template>
    <button v-model="loading" @click="click" :disabled="loading" :class="classes">
        <PulseLoader v-if="loading" size="7px"  :color="setLoaderColor()" />
        <span v-if="!loading">{{ title }}</span>
    </button>
</template>

<script>
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

    export default {
        props: {
            classes: {
              String
            },
            title: {
                type: String
            },
            loading: {
                type: Boolean
            },
            loaderColor: {
                type: String
            }
        },
        components : { PulseLoader },
        methods: {
          click() {
            this.$emit('click', true);
          },
          setLoaderColor() {
               if (this.loaderColor === 'blue') return '#00B2FF';
               return this.loaderColor ? this.loaderColor : '#fff';
          }
        },
    }
</script>